import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NextImageMock = (props: any) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { src, alt, width, height, style, className, onClick, id, onError } = props;
  return (
    <img
      src={src}
      alt={alt || ''}
      width={width}
      height={height}
      style={style}
      className={className}
      onClick={onClick}
      id={id}
      onError={onError}
    />
  );
};

export default NextImageMock;
